import styled from "@emotion/styled";
import { ChevronDown, ChevronUp } from "./ChevronIcons";
import DropdownToggleButton from "./ToggleButton";

/**
 * ChevronToggle — a non-interactive visual wrapper (span) that
 * mirrors DropdownToggleButton's look but renders as an inline element.
 * Use this inside existing button/anchor wrappers where a nested <button>
 * would be invalid HTML.
 */
const Wrapper = styled(DropdownToggleButton.withComponent("span"))``;

interface ChevronToggleProps {
  isOpen: boolean;
  className?: string;
}

const ChevronToggle = ({ isOpen, className }: ChevronToggleProps) => (
  <Wrapper className={className}>
    {isOpen ? <ChevronUp /> : <ChevronDown />}
  </Wrapper>
);

export default ChevronToggle;
